<template>
    <div class="sale_item"
         :style="{ backgroundImage: this.background }"
         @click="openSale(this.item.id)">
        <div class="sale_item_header">
            <div class="sale_item_title">
                {{this.name}}
            </div>
            <div class="sale_item_price">
                <div class="sale_item_price-old">
                    <currency-symbol :price="priceOld"/>
                </div>
                <div class="sale_item_price-new">
                    <currency-symbol :price="priceNew"/>
                </div>
            </div>
        </div>
        <div class="sale_item_description">
            {{this.description}}
        </div>
        <div class="sale_item_icon">
            <img :src="this.icon">
        </div>
    </div>
</template>

<script>
    import api from "../../api";
    import CurrencySymbol from "../CurrencySymbol";

    export default {
        name: "ShopSaleItem",
        components: {CurrencySymbol},
        props: {
            item: {},
        },
        computed: {
            name: function () {
                return this.item.name
            },
            priceNew: function () {
                return this.item.sale_price
            },
            priceOld: function () {
                return this.item.price
            },
            description: function () {
                return this.item.desc
            },
            color: function () {
                return this.item.view_settings.promo_color
            },
            icon: function () {
                return this.item.view_settings.promo_icon !== undefined ? require('../../assets/img/'+this.item.view_settings.promo_icon+'.svg') : require('../../assets/img/gift.svg')
            },
            itemType: function () {
                return this.item.item_type
            },
            background: function () {
                return this.color !== undefined ? 'url(' + require('@/assets/img/promotion_'+this.color+'.png') + ')' : 'url(' + require('@/assets/img/promotion_blue.png') + ')'
            }
        },
        methods: {
            async openSale(itemId) {
                this.$store.commit('SHOW_MODAL_PRELOADER')
                if (this.itemType === 'contract'){
                    let item = (await api.shop.getCatalogContract(itemId)).data;
                    this.$store.commit('SET_SHOP_ITEM_CONTRACT_MODAL', item)
                }else{
                    let item = (await api.shop.getCatalogService(itemId)).data;
                    this.$store.commit('SET_SHOP_ITEM_SERVICE_MODAL', item)
                }
                this.$store.commit('HIDE_MODAL_PRELOADER')
            },
        },
    }
</script>